export const voicePlanCodes = [
    { value: 'UM_VOICE_25G_MAX', label: '移管専用25GB通話プラス(「U-mobileMAX25GB通話プラス」対応)／3,168円/月' }
];
export const dataPlanCodes = [
    { value: 'UM_DATA_25G_MAX', label: '移管専用25GBデータ専用(「U-mobileMAX25GBデータ専用」対応)／2,618/月' },
    { value: 'UM_DATA_1G_S', label: '移管専用1GBデータ専用(「U-mobileSデータ通信専用1GB」対応)／968/月' },
    { value: 'UM_DATA_3G_S', label: '移管専用3GBデータ専用(「U-mobileSデータ通信専用3GB」対応)／1,738/月' },
    { value: 'UM_DATA_7G_S', label: '移管専用7GBデータ専用(「U-mobileSデータ通信専用7GB」対応)／3,278/月' },
    { value: 'UM_DATA_30G_S', label: '移管専用30GBデータ専用(「U-mobileSデータ通信専用30GB」対応)／5,478/月' }
];
export const getPlanCodeLabel = (planType, planCode) => {
    if (planType === 'VOICE') {
        const plan = voicePlanCodes.find((o) => o.value === planCode);
        return plan ? plan.label : '';
    }
    else {
        const plan = dataPlanCodes.find((o) => o.value === planCode);
        return plan ? plan.label : '';
    }
};
